if ( typeof QuickAddModal !== 'function' ) {

  class QuickAddModal extends HTMLElement {

    constructor() {
      super();
      this._initialized = false;
    }

    connectedCallback() {
      if ( this._initialized ) return;
      this._initialized = true;

      this.dialog = this.querySelector('.quick-add-modal__dialog');
      this.productVariants = this.querySelector('product-variants');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[data-js-product-add-to-cart]');
      this.buttonText = this.querySelector('[data-js-product-add-to-cart-text]');

      this._onKeydown = this.onKeydown.bind(this);

      // Move the hidden variant-id <input> from its <template> into the form.
      // (This replaces a per-card inline <script> that used to do the same thing,
      // so the logic now runs once from this deferred, cached file instead of
      // being duplicated in the HTML of every product card.)
      if ( this.form ) {
        const idTemplate = this.querySelector('template[data-js-qa-id-input]');
        if ( idTemplate && !this.form.querySelector('input[name="id"]') ) {
          this.form.append(idTemplate.content.cloneNode(true));
        }
      }

      // Close handlers
      this.querySelectorAll('[data-js-qa-close]').forEach(el => {
        el.addEventListener('click', () => this.close());
      });

      // Add to cart
      if ( this.form ) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      // Show the selected size/variant on the left label (replacing the
      // placeholder). Works with radio-button pills.
      this.querySelectorAll('.quick-add-modal__variant').forEach((variant) => {
        const label = variant.querySelector('[data-js-variant-label]');
        if ( !label ) return;
        const placeholder = label.getAttribute('data-placeholder') || label.textContent;

        // Radio-button style (matches the product page size picker): the label
        // stays as a static heading; the chosen pill is highlighted instead.
        const radios = variant.querySelectorAll('input[type="radio"].product-variant-value');
        if ( radios.length ) {
          return;
        }

        // Fallback: <select> style
        const select = variant.querySelector('select');
        if ( !select ) return;
        const updateLabel = () => {
          const opt = select.options[select.selectedIndex];
          const isPlaceholder = !opt || opt.disabled || !opt.value;
          label.textContent = isPlaceholder ? placeholder : opt.textContent.trim();
        };
        updateLabel();
        select.addEventListener('change', updateLabel);
      });
    }

    open() {
      // Lazy-init the css-slider only once the modal is opened
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-open');
      document.documentElement.classList.add('quick-add-modal-open');

      // Reset the horizontal image strip to the start
      const scroller = this.querySelector('[data-js-qa-scroller]');
      if ( scroller ) {
        scroller.scrollLeft = 0;
      }

      document.addEventListener('keydown', this._onKeydown);
      if ( this.dialog ) {
        requestAnimationFrame(() => this.dialog.focus());
      }
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      this.classList.remove('is-open');
      document.documentElement.classList.remove('quick-add-modal-open');
      document.removeEventListener('keydown', this._onKeydown);
      if ( this._opener && typeof this._opener.focus === 'function' ) {
        this._opener.focus();
      }
    }

    onKeydown(e) {
      if ( e.keyCode === window.KEYCODES.ESC ) {
        this.close();
      }
    }

    onSubmit(e) {
      e.preventDefault();

      if ( this.submitButton.classList.contains('disabled') ) return;

      this.submitButton.classList.add('working');

      window.handleAddToCart(
        this._serializeForm(e.currentTarget), 1,
        {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        () => {
          this.submitButton.classList.remove('working');
          this.close();
        }
      );
    }

    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });
      return arr.join('&');
    }

  }

  if ( typeof customElements.get('quick-add-modal') == 'undefined' ) {
    customElements.define('quick-add-modal', QuickAddModal);
  }

}

/* ---
  Quick Add trigger button (the white +)
  Delegated so it works for cards injected after load (recommendations, Depict, etc.)
--- */

if ( ! window._quickAddTriggerBound ) {

  window._quickAddTriggerBound = true;

  document.addEventListener('click', function(e) {

    const trigger = e.target.closest('[data-js-quick-add-open]');
    if ( ! trigger ) return;

    e.preventDefault();
    e.stopPropagation();
    if ( typeof e.stopImmediatePropagation === 'function' ) {
      e.stopImmediatePropagation();
    }

    const id = trigger.getAttribute('data-quick-add-target');
    if ( ! id ) return;

    const modal = document.getElementById('quick-add-modal-' + id);
    if ( ! modal ) return;

    // Move modal to <body> the first time so it escapes the card's stacking/overflow context
    if ( modal.parentNode !== document.body ) {
      document.body.appendChild(modal);
    }

    modal._opener = trigger;
    modal.open();

  }, true);

}